export const formatDate = (date) => {
  try {
    const today = new Date(date) || new Date();
    // eslint-disable-next-line
    if (today == "Invalid Date") return null;
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy;
    return formattedToday;
  } catch (error) {
    return null;
  }
};

export const formatTime = (date) => {
  try {
    const splitDate = date.split("-");
    const day = splitDate[2];
    const month = splitDate[1];
    const year = splitDate[0];
    return `${day}/${month}/${year}`;
  } catch (error) {
    return null;
  }
  
};
export const transformDate = (data) => {
  const formatDate = new Date(data);
  const result = formatDate.toLocaleDateString("es-MX", data);
  return result;
};
